"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useProjectStatus_1 = __importDefault(require("~/hooks/useProjectStatus"));
const UI_1 = require("~/components/UI");
const assets_1 = require("~/assets");
const react_i18next_1 = require("react-i18next");
const BOMItemNotesButton_scss_1 = __importDefault(require("./BOMItemNotesButton.scss"));
function BOMItemNotesButton({ notesShown, onClick, isNotesPresent, disabled }) {
    const { t } = (0, react_i18next_1.useTranslation)('widgets');
    const { isOrderCompleted, isProjectArchived, isProjectViewOnly } = (0, useProjectStatus_1.default)();
    const getNotesButtonStyle = () => {
        if (notesShown) {
            return BOMItemNotesButton_scss_1.default.selected;
        }
        return isNotesPresent() ? '' : BOMItemNotesButton_scss_1.default.add;
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { style: { cursor: 'pointer' }, className: `${BOMItemNotesButton_scss_1.default.notesImg} ${getNotesButtonStyle()}`, onClick: onClick, "data-disabled": isOrderCompleted || isProjectArchived || isProjectViewOnly || disabled },
            react_1.default.createElement(UI_1.Image, { src: isNotesPresent() ? assets_1.svgBasicNoteIcon : assets_1.svgBasicAddNoteIcon, title: isNotesPresent() ? t('item.view-note') : t('item.add-note') }))));
}
exports.default = BOMItemNotesButton;
